import AppContext from 'context';
import { useContext } from 'react';

const useMenuAccess = () => {
  const { state } = useContext(AppContext);

  const hasAccessToMenu = (item: string): boolean => {
    if (item === 'quotation-freight') return true;

    return state?.user?.data?.company?.combo?.products?.some((product) => product.slug === item);
  };

  return { hasAccessToMenu };
};

export default useMenuAccess;
